<template>
    <a-modal
    :title="title"
    :width="1000"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
      <a-spin :spinning="confirmLoading">
        <a-tabs v-model="activeKey" @change="changeTab">
          <a-tab-pane :key="1" :tab="$t('数据详情')">
            <detail-list :col="3">
              <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
              <detail-list-item :term="$t('表类型')">{{model.meterType?$t(meterTypeObj[model.meterType]):model.meterType}}</detail-list-item>
              <detail-list-item :term="$t('运营商')">{{model.meterIotType?$t(netTypeObj[model.meterIotType]):model.meterIotType}}</detail-list-item>
              <detail-list-item :term="$t('软件版本号')">{{model.meterSoftVersion}}</detail-list-item>
              <detail-list-item term="ST1/ST2">
                <template v-if="model.meterType == '80'&&model.meterStatus3!=null">
                  0x{{model.meterStatus3.toString(16)}}
                </template>
                <template v-else-if="model.meterType == '18'&&model.meterStatus2!=null">
                  0x{{model.meterStatus2.toString(16)}}
                </template>
              </detail-list-item>
              <detail-list-item :term="$t('告警时间')">{{model.updateTime}}</detail-list-item>
              <div v-if="model.meterType == '80'&&model.meterStatus3!=null">
                <a-col :span="6" style="margin-bttom: 16px">
                  <span>bit7: {{(model.meterStatus3&128)!== 0?1:0}}(NRST:{{(model.meterStatus3&128)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit6: {{(model.meterStatus3&64)!== 0?1:0}}(css:{{(model.meterStatus3&64)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit5: {{(model.meterStatus3&32)!== 0?1:0}}(lockup:{{(model.meterStatus3&32)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit4: {{(model.meterStatus3&16)!== 0?1:0}}(PCA:{{(model.meterStatus3&16)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit3: {{(model.meterStatus3&8)!== 0?1:0}}(WDT:{{(model.meterStatus3&8)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span >bit2: {{(model.meterStatus3&4)!== 0?1:0}}(LVD:{{(model.meterStatus3&4)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit1: {{(model.meterStatus3&2)!== 0?1:0}}(bit1:{{(model.meterStatus3&2)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit0: {{(model.meterStatus3&1)!== 0?1:0}}(bit0:{{(model.meterStatus3&1)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
              </div>
              <div v-else-if="model.meterType == '18'&&model.meterStatus2!=null">
                <a-col :span="6" style="margin-bttom: 16px">
                  <span>bit7: {{(model.meterStatus2&128)!== 0?1:0}}(NRST:{{(model.meterStatus2&128)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit6: {{(model.meterStatus2&64)!== 0?1:0}}(css:{{(model.meterStatus2&64)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit5: {{(model.meterStatus2&32)!== 0?1:0}}(BORF:{{(model.meterStatus2&32)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit4: {{(model.meterStatus2&16)!== 0?1:0}}({{ $t('HSI标准') }}:{{(model.meterStatus2&16)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit3: {{(model.meterStatus2&8)!== 0?1:0}}(IWDGF:{{(model.meterStatus2&8)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span >bit2: {{(model.meterStatus2&4)!== 0?1:0}}(LLOPF:{{(model.meterStatus2&4)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit1: {{(model.meterStatus2&2)!== 0?1:0}}(SWIMF:{{(model.meterStatus2&2)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit0: {{(model.meterStatus2&1)!== 0?1:0}}(PORF:{{(model.meterStatus2&1)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
              </div>
              <detail-list-item :term="$t('处理状态')">{{model.meterDealStatus==2?$t('已处理'):model.meterDealStatus==1?$t('处理中'): $t('未处理')}}</detail-list-item>
              <detail-list-item :term="$t('处理描述')" :itemCol="1">{{model.meterDealStatus==2?model.meterWarnDealDescription2:model.meterDealStatus==1?model.meterWarnDealDescription1: model.meterWarnDealDescription0}}</detail-list-item>
            </detail-list>
          </a-tab-pane>
          <a-tab-pane :key="2" :tab="$t('历史复位告警记录')">
            <div class="form-contain">
              <div class="table-page-search-wrapper">
                <a-form layout="inline" @keyup.enter.native="searchQuery">
                  <a-row :gutter="24">
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                      <a-form-item :label="$t('处理状态')">
                        <a-select v-model="queryParam.meterDealStatus" :placeholder="$t('请选择处理状态')">
                          <a-select-option value="0">
                            {{ $t('未处理') }}
                          </a-select-option>
                          <a-select-option value="1">
                            {{ $t('处理中') }}
                          </a-select-option>
                          <a-select-option value="2">
                            {{ $t('已处理') }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :xl="12" :lg="7" :md="8" :sm="24">
                      <a-form-item :label="$t('告警日期')">
                        <a-range-picker
                          v-model="date"
                          format="YYYY-MM-DD"
                          :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                          @change="onDateRangeChange"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="18" style="margin-bottom:24px">
                      <span>bit0: 
                        <a-select v-model="queryParam.bit0" :placeholder="$t('请选择')" style="margin-left:5px;margin-right:5px;margin-bottom:10px;width: 90px">
                          <a-select-option :value="undefined">{{ $t('请选择') }}</a-select-option>
                            <a-select-option
                              v-for="d in bitList"
                              :key="d.key"
                              :value="d.key">
                              {{ d.title }}
                          </a-select-option>
                        </a-select>
                      </span>
                      <span>bit1: 
                        <a-select v-model="queryParam.bit1" :placeholder="$t('请选择')" style="margin-left:5px;margin-right:5px;margin-bottom:10px;width: 90px">
                          <a-select-option :value="undefined">{{ $t('请选择') }}</a-select-option>
                            <a-select-option
                              v-for="d in bitList"
                              :key="d.key"
                              :value="d.key">
                              {{ d.title }}
                          </a-select-option>
                        </a-select>
                      </span>
                      <span>bit2: 
                        <a-select v-model="queryParam.bit2" :placeholder="$t('请选择')" style="margin-left:5px;margin-right:5px;margin-bottom:10px;width: 90px">
                          <a-select-option :value="undefined">{{ $t('请选择') }}</a-select-option>
                            <a-select-option
                              v-for="d in bitList"
                              :key="d.key"
                              :value="d.key">
                              {{ d.title }}
                          </a-select-option>
                        </a-select>
                      </span>
                      <span>bit3: 
                        <a-select v-model="queryParam.bit3" :placeholder="$t('请选择')" style="margin-left:5px;margin-right:5px;margin-bottom:10px;width: 90px">
                          <a-select-option :value="undefined">{{ $t('请选择') }}</a-select-option>
                            <a-select-option
                              v-for="d in bitList"
                              :key="d.key"
                              :value="d.key">
                              {{ d.title }}
                          </a-select-option>
                        </a-select>
                      </span>
                      <span>bit4: 
                        <a-select v-model="queryParam.bit4" :placeholder="$t('请选择')" style="margin-left:5px;margin-right:5px;margin-bottom:10px;width: 90px">
                          <a-select-option :value="undefined">{{ $t('请选择') }}</a-select-option>
                            <a-select-option
                              v-for="d in bitList"
                              :key="d.key"
                              :value="d.key">
                              {{ d.title }}
                          </a-select-option>
                        </a-select>
                      </span>
                      <span>bit5: 
                        <a-select v-model="queryParam.bit5" :placeholder="$t('请选择')" style="margin-left:5px;margin-right:5px;margin-bottom:10px;width: 90px">
                          <a-select-option :value="undefined">{{ $t('请选择') }}</a-select-option>
                            <a-select-option
                              v-for="d in bitList"
                              :key="d.key"
                              :value="d.key">
                              {{ d.title }}
                          </a-select-option>
                        </a-select>
                      </span>
                      <span>bit6: 
                        <a-select v-model="queryParam.bit6" :placeholder="$t('请选择')" style="margin-left:5px;margin-right:5px;margin-bottom:10px;width: 90px">
                          <a-select-option :value="undefined">{{ $t('请选择') }}</a-select-option>
                            <a-select-option
                              v-for="d in bitList"
                              :key="d.key"
                              :value="d.key">
                              {{ d.title }}
                          </a-select-option>
                        </a-select>
                      </span>
                      <span>bit7: 
                        <a-select v-model="queryParam.bit7" :placeholder="$t('请选择')" style="margin-left:5px;margin-right:5px;margin-bottom:10px;width: 90px">
                          <a-select-option :value="undefined">{{ $t('请选择') }}</a-select-option>
                            <a-select-option
                              v-for="d in bitList"
                              :key="d.key"
                              :value="d.key">
                              {{ d.title }}
                          </a-select-option>
                        </a-select>
                      </span>
                    </a-col>
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                      <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                      <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                      <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                      </span>
                    </a-col>
                  </a-row>
                </a-form>
              </div>
              <div>
                <detail-list :col="3">
                  <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
                  <detail-list-item :term="$t('表类型')">{{model.meterType?$t(meterTypeObj[model.meterType]):model.meterType}}</detail-list-item>
                  <detail-list-item :term="$t('运营商')">{{model.meterIotType?$t(netTypeObj[model.meterIotType]):model.meterIotType}}</detail-list-item>
                  <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr?model.userMeterAddr: '--'}}</detail-list-item>
                  <detail-list-item :term="$t('部门编号')">{{model.sysOrgCode}}</detail-list-item>
                  <detail-list-item :term="$t('部门名称')">{{model.departName}}</detail-list-item>
                </detail-list>
              </div>
              <div>
                <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
                  <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
                  <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
                  <a-button v-if="selectedRowKeys.length > 0" style="float: right;margin-left: 8px" type="primary" @click="batchDeal" size="small"> {{ $t('批量处理') }}</a-button>
                </div>
                <a-table 
                  :columns="columns"
                  :dataSource="dataSource"
                  :scroll="{x:true}"
                  rowKey='id'
                  size="middle"
                  :pagination="ipagination"
                  @change="handleTableChange"
                  :loading="loading"
                  class="j-table-force-nowrap"
                  :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,onSelect:onTableSelect,onSelectAll:onSelectAll,getCheckboxProps:getCheckboxProps}"
                >
                  <span slot="meterDealStatus" slot-scope="text, record">
                    <label v-if="record.meterDealStatus === 1" class="doing-status">{{ $t('处理中') }}</label>
                    <label v-else-if="record.meterDealStatus === 2" class="finish-status">{{ $t('已处理') }}</label>
                    <label v-else class="wait-status">{{ $t('未处理') }}</label>
                  </span>
                  <span slot="action" slot-scope="text, record" class="action">
                    <a @click="handleDetail(record)">{{ $t('详情') }}</a>
                    <a :disabled="record.meterDealStatus == 2" @click="handleEdit(record)">{{ $t('处理') }}</a>
                  </span>
                </a-table>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-spin>
      <meter-warn-history-record-deal-modal ref="modalForm" @ok="modalFormOk"></meter-warn-history-record-deal-modal>
      <meter-warn-history-record-detail-modal ref="detailModalForm" @ok="modalFormOk"></meter-warn-history-record-detail-modal>
    </a-modal>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import {netTypeObj} from '@/utils/constants/protocolConstant'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  import meterWarnHistoryRecordDealModal from './meterWarnHistoryRecordDealModal'
  import meterWarnHistoryRecordDetailModal from './meterWarnHistoryRecordDetailModal'
  export default {
    name: 'MeterUserAccountForm',
    mixins:[JeecgListMixin],
    components: {
      JFormContainer,
      DetailList,
      DetailListItem,
      meterWarnHistoryRecordDealModal,
      meterWarnHistoryRecordDetailModal
    },
    data () {
      return {
        model: {},
        title: '',
        confirmLoading: false,
        disableSubmit:false,
        visible: false,
        validatorRules: {
        },
        meterTypeObj,
        netTypeObj,
        url: {
          list: "/jeecg-charge/meter/meterMaintenanceWarnRecord/warnPageList"
        },
        date:[],
        dateType: 2,
        activeKey: 1,
        disableMixinCreated: true,
        uniqueParam: {meterWarnType: 4},
        /* 排序参数 */
        isorter:{
          column: 'updateTime',
          order: 'desc',
        },
        bitList: [
          {
            key: 0,
            title: 0
          },
          {
            key: 1,
            title: 1
          }
        ]
      }
    },
    computed: {
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('处理进度'),
            align:"center",
            dataIndex: 'meterDealStatus',
            scopedSlots: { customRender: 'meterDealStatus' },
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('软件版本号'),
            align:"center",
            dataIndex: 'meterSoftVersion'
          },
          {
            title:'ST1/ST2',
            align:"center",
            dataIndex: 'meterStatus',
            customRender: (t,r,index) => {
              if(r.meterType == '80'&&r.meterStatus3!=null) {
                return  '0x'+r.meterStatus3.toString(16);
              }else if(r.meterType == '18'&&r.meterStatus2!=null) {
                return '0x'+r.meterStatus2.toString(16);
              }
              return '--';
            }
          },
          {
            title: this.$t('告警时间'),
            align:"center",
            dataIndex: 'updateTime',
            width: 100,
            ellipsis: true,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.uniqueParam.meterId = this.model.meterId;
        this.changeTab(1);
        this.disableSubmit = true;
        this.visible = true;
      },
      shut() {
        this.activeKey = 1;
        this.queryParam = {};
        this.list = [];
        this.date = [];
        this.onClearSelected();
      },
      close () {
        this.$emit('close');
        this.shut();
        this.disableSubmit = false;
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.formModal.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })

          }
        })
      },
      handleCancel () {
        this.close()
      },
      changeTab() {
        if(this.activeKey == 2) {
          this.loadData(1)
        }
      },
      handleDetail:function(record){
        this.$refs.detailModalForm.edit(record);
        this.$refs.detailModalForm.title=this.$t("详情");
        this.$refs.detailModalForm.disableSubmit = true;
      },
      handleEdit: function (record) {
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = this.$t("处理");
        this.$refs.modalForm.disableSubmit = false;
      },
      getCheckboxProps(record) {
        let props = {
          disabled: record.meterDealStatus == 2,
          meterDealStatus: record.meterDealStatus
        }
        return {props: {...props}};
      },
      batchDeal() {
        // 批量处理告警
        if(this.selectionRows.length<1){
          this.$message.error(this.$t("请先选择需要批量处理的记录"))
          return
        }else{
          let idList = []
          let meterDealStatus = ''
          for(let i = 0;i<this.selectionRows.length;i++) {
            if(i === 0) {
              meterDealStatus = this.selectionRows[0].meterDealStatus
            }else{
              if(meterDealStatus !== this.selectionRows[i].meterDealStatus) {
                this.$message.error(this.$t("选择批量处理的处理进度不一致不能操作，请重新选择同一处理进度的表具"))
                return
              }
            }
            idList.push(this.selectionRows[i].id)
          }
          let record = {}
          record.idList = idList.join(',')
          record.meterDealStatus = meterDealStatus
          record.meterWarnType = this.uniqueParam.meterWarnType
          this.handleEdit(record)
        }
      },
    }
  }
</script>
<style scoped>
.detail-list >>> .term{
  line-height: 22px;
}
</style>